import * as kea from "kea-react";
import * as resources from "app/resources/index";
import { observeResource } from "kea-resource";
import { nextToPromise } from "keautils";

const interval = 5;

const tiempoLimite = observeResource(resources.ConfigSistema.LimiteTiempoSesion);
/**Ejecuta una acción después de cierto tiempo de inactividad. Devuelve una función que al ejecutar cancela el contador */
export async function EnInactividad(action: () => void): Promise<() => void> {
    const keyCacheInactividad = "keyCacheInactividad";
    /**Obtiene la fecha de hoy en segundos */
    const hoy = () => new Date().valueOf() / 1000;
    /**Obtiene el tiempo transcurrido en segundos desde el ultimo resetInterval */
    const transcurrido = () => hoy() - kea.cookies.Get(keyCacheInactividad);
    const resetInterval = () => {
        kea.cookies.Set(keyCacheInactividad, hoy());
    }
    const handleInterval = async () => {
        const t = transcurrido();
        var segundos = await nextToPromise(tiempoLimite);
        if (t >= segundos) {
            action();
        }
    }

    window.addEventListener("mousedown", resetInterval);
    window.addEventListener("mousemove", resetInterval);
    window.addEventListener("keydown", resetInterval);

    //Reseteamos el intervalo:
    resetInterval();
    const intervalIndex = setInterval(handleInterval, interval * 1000);

    return () => {
        clearInterval(intervalIndex);
        window.removeEventListener("mousedown", resetInterval);
        window.removeEventListener("mousemove", resetInterval);
        window.removeEventListener("keydown", resetInterval);
    };
}



// WEBPACK FOOTER //
// ./app/features/componentes/inactividad.ts